import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrderStoreSelectors } from '../selectors';

import { OrderActions } from '../actions';
import { IOrderFeatureState } from '../reducers';

@Injectable({
  providedIn: 'root',
})
export class OrderStoreFacade {
  constructor(private readonly store: Store<IOrderFeatureState>) {}

  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  orderSummary$ = this.store.select(OrderStoreSelectors.selectOrderSummary);

  order$ = this.store.select(OrderStoreSelectors.selectOrderResponse);

  orderTickets$ = this.store.select(OrderStoreSelectors.selectOrderTickets);

  orderTicketIds$ = this.store.select(OrderStoreSelectors.selectOrderTicketIds);

  orderLoaded$ = this.store.select(OrderStoreSelectors.selectOrderLoadState);

  isOrderSummaryLoading$ = this.store.select(
    OrderStoreSelectors.selectOrderLoading
  );

  loadOrder(orderNumber: string) {
    this.store.dispatch(
      OrderActions.orderAPI_loadOrder({
        orderNumber,
      })
    );
  }

  clearOrder() {
    this.store.dispatch(OrderActions.clearOrder());
  }
}
